/**
 * ALDER SEARCH — App Root
 * Design: "Alder Forest — Organic Precision"
 * Light theme (warm cream background)
 */

import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import InsightsPage from "./pages/InsightsPage";
import ArticlePage from "./pages/ArticlePage";
import LeadMagnetPage from "./pages/LeadMagnetPage";
import PrivacyPage from "./pages/PrivacyPage";
import SeniorLeadershipPage from "./pages/SeniorLeadershipPage";
import ExecutiveSearchPage from "./pages/ExecutiveSearchPage";
import ApproachPage from "./pages/ApproachPage";
import CpoSearchPage from "./pages/CpoSearchPage";
import FractionalInterimPage from "./pages/FractionalInterimPage";
import BoardDirectorPage from "./pages/BoardDirectorPage";
import LeadershipBuildoutsPage from "./pages/LeadershipBuildoutsPage";
import HeadOfProductPage from "./pages/HeadOfProductPage";
import VpSpecialistPage from "./pages/VpSpecialistPage";
import ScorecardPage from "./pages/ScorecardPage";
import ArrHiringGapCheckPage from "./pages/ArrHiringGapCheckPage";
import HiringDecisionEnginePage from "./pages/HiringDecisionEnginePage";
import BookingPage from "./pages/BookingPage";
import FunnelPage from "./pages/FunnelPage";
import ScrollToTop from "./components/ScrollToTop";
import CanonicalUrl from "./components/CanonicalUrl";

function Router() {
  return (
    <>
      <ScrollToTop />
      <CanonicalUrl />
      <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/insights"} component={InsightsPage} />
      <Route path={"/insights/why-product-managers-get-rejected"}>{() => <LeadMagnetPage guideSlug="why-product-managers-get-rejected" />}</Route>
      <Route path={"/insights/why-pm-linkedin-profiles-get-passed-over"}>{() => <LeadMagnetPage guideSlug="why-pm-linkedin-profiles-get-passed-over" />}</Route>
      <Route path={"/insights/the-cto-as-value-creation-partner"}>{() => { window.location.replace("/insights/the-cpo-as-value-creation-partner"); return null; }}</Route>
      <Route path={"/insights/:slug"} component={ArticlePage} />
      <Route path={"/privacy"} component={PrivacyPage} />
      <Route path={"/senior-leadership"} component={SeniorLeadershipPage} />
      <Route path={"/executive-search"} component={ExecutiveSearchPage} />
      <Route path={"/approach"} component={ApproachPage} />
      <Route path={"/scorecard"} component={ScorecardPage} />
      <Route path={"/arr-hiring-gap-check"} component={ArrHiringGapCheckPage} />
      <Route path={"/hiring-decision-engine"} component={HiringDecisionEnginePage} />
      <Route path={"/book"} component={BookingPage} />
      <Route path={"/funnel"} component={FunnelPage} />
      <Route path={"/executive-search/ceo-search"}>{() => { window.location.replace("/executive-search"); return null; }}</Route>
      <Route path={"/executive-search/cto-search"}>{() => { window.location.replace("/executive-search"); return null; }}</Route>
      <Route path={"/executive-search/cpo-search"} component={CpoSearchPage} />
      <Route path={"/executive-search/operating-partner-recruitment"}>{() => { window.location.replace("/executive-search"); return null; }}</Route>
      <Route path={"/executive-search/fractional-interim-leadership"} component={FractionalInterimPage} />
      <Route path={"/executive-search/board-director-placement"} component={BoardDirectorPage} />
      <Route path={"/executive-search/leadership-team-buildouts"} component={LeadershipBuildoutsPage} />
      <Route path={"/senior-leadership/head-of-product-search"} component={HeadOfProductPage} />
      <Route path={"/senior-leadership/head-of-engineering-search"}>{() => { window.location.replace("/senior-leadership"); return null; }}</Route>
      <Route path={"/senior-leadership/vp-specialist-search"} component={VpSpecialistPage} />
      <Route path={"/senior-leadership/head-of-design-search"}>{() => { window.location.replace("/senior-leadership"); return null; }}</Route>
      <Route path={"/404"} component={NotFound} />
      {/* Redirect /components (dev template page, never public) to homepage */}
      <Route path={"/components"}>{() => { window.location.replace("/"); return null; }}</Route>
      <Route component={NotFound} />
    </Switch>
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
